import React, { useRef } from "react"
import { useInView } from "framer-motion"

import { Container } from "../Container"

import "./testimonial.css"

const Testimonial = ({ content, clientHighlight }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    return (
        <Container>
            <div ref={ref} className="pt-30 testimonial">
                <h3 
                    style={{
                        opacity: isInView ? 1 : 0,
                        transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                    }}
                    className="mb-0 uppercase text-center"
                >{content.testimonialTitle}</h3>
                <div className="grid col-3 col-2-md col-1-xs col-1-md gap-20 gap-15-md">
                    {clientHighlight?.map((item, index) => {
                        const videoId = item.videoLink ? item.videoLink.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)[1] : '';
                        const youtubeEmbedLink = `https://www.youtube.com/embed/${videoId}`;
                        return (
                            <div 
                                key={index}
                                style={{
                                    opacity: isInView ? 1 : 0,
                                    transition: `all ${.9 * index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${.9 * index}s`
                                }}
                            >
                                <h4 className="mb-0 text-center heading-four--small">{item.name}</h4>
                                <iframe 
                                width="424" 
                                height="238" 
                                src={youtubeEmbedLink} 
                                title={item.name}
                                frameBorder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                allowFullScreen></iframe>
                            </div>
                        )
                    })}
                </div>
            </div>
        </Container>
    )
}

export default Testimonial